"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var twilsockerror_1 = require("./twilsockerror");

var TransportUnavailableError =
/*#__PURE__*/
function (_twilsockerror_1$Twil) {
  _inherits(TransportUnavailableError, _twilsockerror_1$Twil);

  function TransportUnavailableError(description) {
    _classCallCheck(this, TransportUnavailableError);

    return _possibleConstructorReturn(this, _getPrototypeOf(TransportUnavailableError).call(this, description));
  }

  return TransportUnavailableError;
}(twilsockerror_1.TwilsockError);

exports.TransportUnavailableError = TransportUnavailableError;